<template>
  <VModal :show="show" title="لیست غذابر">

    <div class="flex mt-4">
      <Input placeholder="نام غذابر" v-model="name"/>
      <Button class="w-auto mr-2" @click="edit ? update(edit.Code, name, '0') : create()">
        {{ edit ? 'ویرایش' : 'ایجاد'}}
      </Button>
    </div>

    <div class="p-4">
      <table class="w-full text-white mt-4 divide-y divide-gray-400">
        <thead class="text-right">
        <tr>
          <th class="py-2">نام</th>
          <th class="text-center">فعال</th>
          <th class="text-center">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="boy in deliveryBoys" :key="boy.Code" :class="{'bg-red-500/40' : boy.IsDisable === '1'}">
          <td class="py-2">{{ boy.Name }}</td>
          <td class="py-2 text-center">{{ boy.IsDisable === '1' ? 'خیر' : 'بله' }}</td>
          <td class="py-2 flex justify-around">
            <PencilAltIcon class="w-5 cursor-pointer text-yellow-500" @click="edit = boy; name = boy.Name"/>
            <CheckIcon class="w-5 cursor-pointer text-green-500" @click="update(boy.Code, boy.Name, '0')"/>
            <XIcon class="w-5 cursor-pointer text-red-500" @click="update(boy.Code, boy.Name, '1')"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </VModal>
</template>

<script>
import VModal from "../General/VModal";
import {createDeliveryBoy, getDeliveryBoyList, updateDeliveryBoy} from "../../API/API";
import Input from "../Input";
import Button from "../General/Button";
import {CheckIcon, PencilAltIcon, XIcon} from "@heroicons/vue/outline";

export default {
  name: "DeliveryBoyModal",
  props: ['show', 'monitorId', 'kitchenType'],
  components: {Button, Input, VModal, PencilAltIcon, CheckIcon, XIcon},
  data() {
    return {
      deliveryBoys: [],

      name: '',
      edit: ''
    }
  },
  async created() {
    this.deliveryBoys = (await getDeliveryBoyList(this.monitorId)).data.result
  },
  methods: {
    create() {
      createDeliveryBoy(this.name, 0, this.monitorId)
          .then(async () => {
            this.name = ''
            this.deliveryBoys = (await getDeliveryBoyList(this.monitorId)).data.result
          })
    },
    update(Code, Name, isDisabled) {
      updateDeliveryBoy(Code, Name, isDisabled, this.monitorId)
          .then(async () => {
            this.edit = ''
            this.name = ''
            this.deliveryBoys = (await getDeliveryBoyList(this.monitorId)).data.result
          })
    }
  },
  watch: {
    async 'monitorId'() {
      this.deliveryBoys = (await getDeliveryBoyList(this.monitorId)).data.result
    }
  }
}
</script>

<style scoped>

</style>